import Client, { clientFromDocument, DocumentClientFields } from "../models/client";
import { SUCCESS } from "../utils/constants/tags";
import { getList } from "./generics";

const getClientById = async (
  id?: number | null,
  taxPayerId?: number | null
): Promise<Client | null> => {
  if (id == null) {
    return null;
  }

  let params: Map<string, string> = new Map();
  if (id !== undefined) {
    params.set("id", id.toString());
  }

  if (taxPayerId != null) {
    params.set("tax_payer_id", taxPayerId.toString());
  }

  const requestStatus = await getList<Client>("/clients/", 1, 0, params);

  if (
    requestStatus.status === SUCCESS &&
    requestStatus.data !== undefined &&
    requestStatus.data.items.length > 0
  ) {
    return requestStatus.data!.items[0];
  }

  return null;
};

const getClientForDocument = async (
  document: DocumentClientFields
): Promise<Client | null> => {
  const linkedClient = await getClientById(document.clientId, document.taxPayerId);
  return linkedClient ?? clientFromDocument(document);
};

export { getClientById, getClientForDocument };
